import {
  Box,
  Button,
  Container,
  Flex,
  Input,
  Menu,
  Select,
  Text,
} from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import AddButton from "../../../components/AddButton";
import NoteModal from "../../../components/NoteModal";
import NoteTypeSelectModal from "../../../components/NoteSelectTypeModal";
import NoteTable from "../../../components/NoteTable";
import CustomPagination from "../../../components/Pagination/CustomPagination";
import { getAllFacilitiesModal, getAllFacilityTypes } from "../../../services";
import { getAllNoteTypes, getNotes } from "../../../services/note";
import { getAllPatientsModal } from "../../../services/patient";
import { getAllStaff } from "../../../services/staff";
import moment from "moment";
import { DatePickerInput } from "@mantine/dates";
import { FilterIcon } from "../../../components/Svgs/FilterIcon";
import useStyles from "./style";
import { FaSort } from "react-icons/fa6";
import AddEssentialNote from "../../../components/AddEssentialNote/AddEssentialNote";
import { Billing_Services_Note, Essential_Support_Note } from "../../../http";
import NoteDrawer from "../../../components/NoteModal/NewNoteDesignCopy";
import { NewAddButton } from "../../../components/AddButton/NewAddButton";
import { NotetTypeSvg } from "../../../components/Svgs/NotetTypeSvg";
import { RxCross2 } from "react-icons/rx";
import { LuCalendar } from "react-icons/lu";
import { IoFilter } from "react-icons/io5";
import { IconSearch } from "@tabler/icons-react";
import NoteModalNew from "../../../components/NoteModal/NoteModalNew";

const ClientNoteview = ({ userId, activeTab }) => {
  const { classes } = useStyles();

  const [data, setData] = useState(null);
  const [view, setView] = useState(false);
  const [isopen, setOpen] = useState(false);
  const [noteType, setNoteType] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const { notes, loading } = useSelector((state) => state?.note);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [opened, { open, close }] = useDisclosure(false);
  const [dateRange, setDateRange] = useState(null);
  const [dateRangeVal, setDateRangeVal] = useState([]);
  const [oneDayValue, setOneDayValue] = useState(null);
  const [billingServices, setBillingServices] = useState("");
  const [progressNoteState, setProgressNoteState] = useState("");
  const [createdAt, setCreatedAt] = useState(null);
  const [isViewNoteOpen, setIsViewNoteOpen] = useState(false);

  const [openModal, setOpenModal] = useState(false);

  const [sortOpen, setSortOpen] = useState(false);
  const [sortField, setSortField] = useState("noteDate");
  const [sortOrder, setSortOrder] = useState("descending");

  useEffect(() => {
    getAllNoteTypes();
    getAllFacilityTypes();
    getAllPatientsModal();
    getAllFacilitiesModal("all");
  }, []);

  useEffect(() => {
    if (activeTab === "notes") {
      getAllStaff("all");
    }
  }, [activeTab]);

  useEffect(() => {
    getNotes(currentPage, userId, true, dateRange, sortField, sortOrder);
  }, [currentPage, dateRange]);

  const handleDateRange = (dates) => {
    if (dates[0] == null && dates[1] == null) {
      setDateRangeVal([]);
    } else {
      setDateRangeVal(dates);
    }
  };

  const handleDateChange = (date) => {
    setOneDayValue(date);
  };

  // const handleCreatedAt = (date) => {
  //   let startDate = moment(dateRangeVal[0]);
  //   setCreatedAt()
  // };

  const handleSaveDateRange = () => {
    if (dateRangeVal?.length) {
      let startDate = moment(dateRangeVal[0]).startOf("day");
      let endDate = moment(dateRangeVal[1]).endOf("day");
      setDateRange([startDate, endDate]);
    } else if (oneDayValue) {
      let startDate = moment(oneDayValue).startOf("day");
      let endDate = moment(oneDayValue).endOf("day");
      setDateRange([startDate, endDate]);
    }
    setDropdownOpen(false);
  };

  const handleCancelDateRange = () => {
    setDateRangeVal([]);
    setDateRange(null);
    setDropdownOpen(false);
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleSortChange = (field, order) => {
    setSortField(field);
    setSortOrder(order);
  };

  // const handleAddEssential = () => {
  //   setNoteType(Essential_Support_Note);
  //   setOpen(true);
  // };
  const handleAddEssential = () => {
    if (billingServices) {
      setNoteType(Billing_Services_Note);
    } else {
      setNoteType(Essential_Support_Note);
    }
    setOpen(true);
  };
  return (
    <Container fluid className={classes.content} px={20}>
      {/* Note Modal */}
      <AddEssentialNote
        openModal={openModal}
        setOpenModal={setOpenModal}
        onConfirm={handleAddEssential}
        billingServices={billingServices}
        setBillingServices={setBillingServices}
      />
      <NoteDrawer
        close={() => {
          setOpen(false);
          setData(null);
          setNoteType(null); // Reset note type
        }}
        // view={view}
        data={data}
        userId={userId}
        opened={isopen}
        setView={setView}
        noteType={noteType}
        title={"Add New Note"}
        setOpenModal={setOpenModal}
        setBillingServices={setBillingServices}
        setProgressNoteState={setProgressNoteState}
        progressNoteState={progressNoteState}
      />
      <NoteModalNew
        opened={isViewNoteOpen}
        close={() => {
          setIsViewNoteOpen(false);
          setData(null);
        }}
        hideApproveRejectButtons={true}
        noteType={noteType}
        title={"Add New Note"}
        view={view}
        setView={setView}
        data={data}
      />

      {/* Filter and Add Button */}
      <Box className={classes.btn}>
        <Flex align={"center"} gap={10}>
          <Flex align={"center"} gap={10}>
            <Text className={classes.titleText}>All Notes</Text>
          </Flex>
          {/* <Box className={classes.FilterIcon}>
            <Menu
              width={350}
              shadow="md"
              opened={sortOpen}
              position="bottom-start"
              onClose={() => setSortOpen(false)}
            >
              <Menu.Target title="Sort">
                <Box
                  className={classes.FilterIcon}
                  onClick={() => setSortOpen(!sortOpen)}
                >
                  <FaSort size={30} />
                </Box>
              </Menu.Target>

              <Menu.Dropdown>
                <Text size="md" weight={500} ml={5} mt={10} mb={5}>
                  Sorting
                </Text>
                <Select
                  label="Sort By"
                  placeholder="Sort by"
                  data={[
                    { label: "Created Date", value: "createdAt" },
                    { label: "Note Date", value: "noteDate" },
                    { label: "Edited Date", value: "updatedAt" },
                  ]}
                  value={sortField}
                  onChange={(value) => handleSortChange(value, sortOrder)}
                />
                <Select
                  label="Sort Order"
                  placeholder="Sort Order"
                  data={[
                    { label: "Ascending", value: "ascending" },
                    { label: "Descending", value: "descending" },
                  ]}
                  value={sortOrder}
                  onChange={(value) => handleSortChange(sortField, value)}
                />
                <Box className={classes.filterBtn}>
                  <Button
                    size="sm"
                    radius={8}
                    color="yellow"
                    disabled={loading}
                    onClick={() =>
                      getNotes(
                        currentPage,
                        null,
                        true,
                        dateRange,
                        sortField,
                        sortOrder
                      )
                    }
                  >
                    Save
                  </Button>
                </Box>
              </Menu.Dropdown>
            </Menu>
          </Box> */}
        </Flex>

        <Box className={classes.rightBTN}>
          <Menu
            width={380}
            shadow="md"
            position="bottom"
            opened={dropdownOpen}
            classNames={{ dropdown: classes.notesFilterBox }}
            onClose={() => setDropdownOpen(false)}
          >
            <Menu.Target title="Filter">
              <Button
                size="md"
                radius="md"
                title="Filter"
                leftIcon={<IoFilter />}
                onClick={() => setDropdownOpen(!dropdownOpen)}
                color="gray"
                variant="outline"
              >
                Filter
              </Button>
            </Menu.Target>

            <Menu.Dropdown>
              <Box className="header">
                <Text>Filter</Text>
                <Button variant="unstyled" onClick={handleCancelDateRange}>
                  <RxCross2 size={24} />
                </Button>
              </Box>
              <Box className="filterBody">
                <Box className="fieldParent">
                  <DatePickerInput
                    size="sm"
                    radius={"md"}
                    withinPortal={false}
                    clearable
                    sx={{
                      minWidth: "75%",
                      maxWidth: "fit-content",
                    }}
                    type="range"
                    icon={<LuCalendar color="#262626" size={20} />}
                    value={dateRangeVal}
                    disabled={oneDayValue}
                    className="datePicker"
                    label="Select Date Range"
                    onChange={handleDateRange}
                    placeholder="Select Date Range"
                  />
                </Box>
                <Box className="fieldParent">
                  <DatePickerInput
                    radius={"md"}
                    clearable
                    withinPortal={false}
                    w="fit-content"
                    icon={<LuCalendar color="#262626" size={20} />}
                    size="sm"
                    className="datePicker"
                    value={oneDayValue}
                    label="Select Date"
                    placeholder="Select Date"
                    onChange={handleDateChange}
                    disabled={dateRangeVal?.length}
                  />
                </Box>
              </Box>
              <Box className="boxFooter">
                <Button
                  variant="outline"
                  onClick={handleCancelDateRange}
                  className="resetBtn"
                >
                  Reset
                </Button>
                <Button
                  className="applyBtn"
                  disabled={loading}
                  onClick={handleSaveDateRange}
                >
                  Apply
                </Button>
              </Box>
            </Menu.Dropdown>
          </Menu>
          <NewAddButton
            title="Add Note"
            icon={<NotetTypeSvg />}
            onClick={() => {
              getAllStaff("all");
              setOpen(true);
            }}
            color="#FFAF4A"
            textColor="#000"
            variant="filled"
            borderColor="none"
          />
        </Box>
      </Box>
      <Box className={classes.table}>
        <Box>
          <Input
            className={classes.searchInput}
            variant="filled"
            size="sm"
            placeholder="Search"
            icon={<IconSearch />}
            mb={10}
          />
          <NoteTable
            openModal={(data) => {
              setData(data);
              setOpen(true);
            }}
            openViewModal={(data) => {
              setData(data);
              setIsViewNoteOpen(true);
            }}
            setView={(data) => {
              setView(true);
            }}
            userId={userId}
            loading={loading}
          />
        </Box>
        <CustomPagination
          itemsPerPage={10}
          data={notes?.count}
          currentPage={currentPage}
          handlePageChange={handlePageChange}
        />
      </Box>
    </Container>
  );
};

export default ClientNoteview;
